import { render } from "./PromotionSection.vue?vue&type=template&id=6cb4e9b6&scoped=true&ts=true"
import script from "./PromotionSection.vue?vue&type=script&lang=ts"
export * from "./PromotionSection.vue?vue&type=script&lang=ts"

import "./PromotionSection.vue?vue&type=style&index=0&id=6cb4e9b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb4e9b6"]])

export default __exports__